import BaseView from '../../../js/base-view';
import lineClamp from '../../../js/utils/line-clamp';

const SELECTOR_CARD_IMAGE = '.card-article__image';
const SELECTOR_CARD_CATEGORY = '.card-article__category';
const SELECTOR_CARD_FOOTER = '.card-article__footer';
const SELECTOR_CARD_DETAILS = '.card-article__details';
const SELECTOR_CARD_TITLE = '.card-article__title';
const SELECTOR_CARD_EXCERPT = '.card-article__excerpt';

const DEFAULT_MAX_LINES = 4;

export default class CardArticle extends BaseView {
	init() {
		const excerpt = this.el.querySelector(SELECTOR_CARD_EXCERPT);

		// bail early if no excerpt
		if (excerpt === null) {
			return;
		}

		// refs
		// to keep reference of scoped dom elements
		this.refs = {
			image: this.el.querySelector(SELECTOR_CARD_IMAGE),
			category: this.el.querySelector(SELECTOR_CARD_CATEGORY),
			footer: this.el.querySelector(SELECTOR_CARD_FOOTER),
			details: this.el.querySelector(SELECTOR_CARD_DETAILS),
			title: this.el.querySelector(SELECTOR_CARD_TITLE),
			excerpt,
		};

		// Cache computed styles
		// Try to find how to avoid these.
		this.styles = {
			el: getComputedStyle(this.el),
			details: getComputedStyle(this.refs.details),
			excerpt: getComputedStyle(this.refs.excerpt),
		};

		// Bail early if the excerpt is already hidden
		if (this.styles.excerpt.display !== 'none') {
			/**
			 * If card is in a vertical, flex-based (and not grid-based) layout,
			 * line-clamp excerpt at the number of max default lines (see constant).
			 * (will probably be truncated by WordPress anyway).
			 *
			 * Else (not a flex-based card), run the calculations for available lines
			 * depending on the image height.
			 */
			if (this.styles.el.display !== 'flex') {
				this.setDataLineClamp(this.refs.excerpt, this.getAvailableLinesForExcerpt());
			}
			else {
				this.setDataLineClamp(this.refs.excerpt, DEFAULT_MAX_LINES);
			}
		}
	}

	/**
	 * Loads the next unicorn
	 */
	getAvailableLinesForExcerpt() {
		const imageHeight = this.refs.image.clientHeight;

		const usedHeight =
			this.refs.category.clientHeight +
			this.refs.title.clientHeight +
			this.refs.footer.clientHeight +
			parseInt(this.styles.details.paddingBottom); // TODO find how to avoid this

		const availableHeight = imageHeight - usedHeight;

		/**
		 * Compensating with - 0.4 to allow for some "margin" for
		 * the calculated number of available lines
		 * (if for instance availableLinesForExcerpt, non-rounded,
		 * gives a result of 3.15 lines, actually we don't really
		 * have the room for 3 lines to be displayed)
		 *
		 * Also, using Math.max to choose between 0 and the calculated value
		 * because negative line-clamp values do not work with lineclamp.js
		 */
		let availableLinesForExcerpt =
			// eslint-disable-next-line max-len
			Math.max(0, Math.floor(availableHeight / parseInt(this.styles.excerpt.lineHeight) - 0.4));

		if (availableLinesForExcerpt > DEFAULT_MAX_LINES) {
			availableLinesForExcerpt = DEFAULT_MAX_LINES;
		}

		return availableLinesForExcerpt;
	}

	setDataLineClamp(element, maxLines) {
		if (this.styles.el.display === 'none') {
			return;
		}
		element.setAttribute('data-line-clamp', maxLines);
		lineClamp();
	}
}

